import React from 'react';
import { useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MOBILE_STARS, PHONE_CODE } from '../../lib';

export default function SpecialInstructions(props: any) {
    const inst = useSelector((state: any) => state.cart.special_instructions);
    const inst2 = useSelector((state: any) => state.cart.alternate_number);
    const { t } = useTranslation();

    const handleEnterPress = (e: any) => { 
        if (e.key === 'e' || e.key === '+' || e.key === '-') {
            e.preventDefault()
        }
        if(e.target.value.length >= 10) {
            e.preventDefault()
        }
    }

    return (
        <div>
            <div className='cart-items'>
                <div className='special-instruction'>
                    <label className='special-title color-white'>{t("SPECIAL_INSTRUCTIONS_OPTIONAL")}</label>
                    <div className='flex flex-col gap-2'>
                        <div className="form-group">
                            <textarea onChange={props.handleSpecialInstruction} maxLength={250} defaultValue={inst} className="form-control special-text-area" placeholder={t("COOKING_DELIVERY_INSTRUCTIONS")} id="exampleFormControlTextarea1" rows={2}></textarea>
                        </div>
                        <TextField
                            onKeyPress={handleEnterPress}
                            name="input1"
                            value={inst2}
                            onChange={props.handleAternateNumber}
                            autoComplete="mobile tel"
                            className="field-style arabic-dir"
                            label={`${t("ALTERNATE_PHONE_NUMBER")} (${MOBILE_STARS})`}
                            variant="filled"
                            color="error"
                            type="number"
                            id="outlined-number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                startAdornment: 
                                <InputAdornment
                                    className="number-field"
                                    position="start"
                                >
                                    {PHONE_CODE}
                                </InputAdornment>,
                                inputMode: 'numeric',
                            }
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
